import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import HomepageTemplate from '../components/Homepage.js';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HomepageTemplate;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <PageDescription mdxType="PageDescription">
      <h2>{`Getting Started`}</h2>
    </PageDescription>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="CloudPak for AIOps" subTitle="Get Started with" href="/01-introduction/01-introduction" readTime="  7-8h" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/dash.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Turbonomic" subTitle="Get Started with" href="/12-install-turbonomic/12-install-turbonomic-01" readTime="1h" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/00_turbo.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
    </Row>
    <PageDescription mdxType="PageDescription">
      <h2>{`IBM AIOps Training - Modules`}</h2>
    </PageDescription>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Introduction" subTitle="🚀 Get Started Here" href="/01-introduction/01-introduction" readTime="  15 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/intro.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Prerequisites" href="/02-prerequisites/02-prerequisites-01" readTime="30 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/prereq.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Install the Operator" href="/03-installing-operator/03-installing-operator-02" readTime="15 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/operator.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Install CP4AIOPS" href="/04-installing-aimanager/04-installing-aimanager-01" readTime="120 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/aimanager.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Install Training resources" href="/05-installing-training-resources/05-installing-training-resources-01" readTime="45 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/training.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Configure CP4AIOPS" href="/06-configure-aimanager/06-configure-aimanager-01" readTime="180 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/story.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Train the Models" href="/07-train-the-models/07-train-the-models-01" readTime="30 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/models.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="CP4AIOPS Demo Script" href="/08-test-and-demo/08-test-and-demo-01" readTime="45 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/dash.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Configure Slack (optional)" href="/10-configure-slack/10-configure-slack-01" readTime="60 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/slack.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Configure ServiceNow (optional)" href="/11-configure-servicenow/11-configure-servicenow-01" readTime="60 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/snow.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Troubleshooting" href="/50-troubleshooting/50-troubleshooting-01" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/Article_06.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
    </Row>
    <PageDescription mdxType="PageDescription">
      <h2>{`Instana Training - Modules`}</h2>
    </PageDescription>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Install Instana" href="/09-configure-instana/09-configure-instana-00" readTime="30 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/instana.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Configure Instana" href="/09-configure-instana/09-configure-instana-02" readTime="30 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/instana_app_04.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
    </Row>
    <PageDescription mdxType="PageDescription">
      <h2>{`Turbonomic Training - Modules`}</h2>
    </PageDescription>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Install Turbonomic" href="/12-install-turbonomic/12-install-turbonomic-01" readTime="30 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/00_turbo.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Configure Turbonomic" href="/13-configure-turbonomic/13-configure-turbonomic-01" readTime="30 min" actionIcon="arrowRight" mdxType="ArticleCard">
          <img {...{
            "src": "./images/cards/01_turbo.png",
            "alt": "Dark article layout mockup"
          }}></img>
        </ArticleCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      